<template>

    <div class="user">
        <sku_prices></sku_prices>

    </div>
  </template>
  
  <script>


    import sku_prices from './../../../product/sku/sku_prices.vue';

    export default {
      components: {
        sku_prices,
      },

      data() {
        return {
    
        };
      },
      created() {
  

      },
      methods: {
      
      }
    };
  </script>
  
  <style></style>
  


// WEBPACK FOOTER //
// src/views/plus/existing_inventory/index/sku_price.vue